export default __webpack_public_path__ + "a6689b0f4f4fd07da71d7bebd1115db8.svg";